<template>
    <div :class="{'form-group':true, 'has-errors': fieldErrors }">
        <label v-if="label" :for="id" v-html="label"></label>

        <div class="ninja-input">
            <select :id="id"
                    :name="name"
                    :multiple="multiple"
                    :disabled="disabled"
                    :required="required"
                    @change="handleInput"
                    @blur="handleBlur"
                    @focus="handleFocus"
                    class="form-control">
                <option value="">Select a state...</option>
                <option v-for="(option, key) in options" :value="key" v-text="option"
                        :selected="checkSelected(key)"></option>
            </select>
            <div class="ninja-bars">
                <div class="ninja-bar ninja-focus"></div>
                <div class="ninja-bar ninja-error"></div>
            </div>
        </div>
        <ul class="form-errors" v-if="fieldErrors">
            <li v-for="error in fieldErrors">{{ error }}</li>
        </ul>
    </div>
</template>

<script>
    import VuexSelectMixin from "vuex-forms/lib/mixins/vuex-select"
    export default {
        name: 'FormSelect',
        mixins: [VuexSelectMixin()]
    }
</script>


// WEBPACK FOOTER //
// FormSelect.vue?5a145383